import axios, { AxiosResponse, AxiosRequestConfig, AxiosPromise } from 'axios';
import { ROOT_PATH } from '@/origin';
import { message } from 'antd';
import { md5sign } from './md5sign';
import { showLoading, hideLoading } from '@/utils/loading';
import { clearExcept, getAllParams } from '@/utils/tools';

type CustomerAxiosRequestConfig = AxiosRequestConfig & { headers?: { [k: string]: any }, options?: { loading: boolean } };
type CodeMapType = { [k: string | number]: string };
type CodeType = keyof CodeMapType;

export interface Data { [key: string]: any };
export interface ResponseData<U = Data> { data: U, code: CodeType, msg: string, };

const { localStorage, location } = window;

// 提取获取 token 的逻辑
const getToken = (): string => {
  const baseToken = localStorage.getItem('token');
  if (baseToken) {
    return baseToken;
  }
  const urlToken = getAllParams().token || '';
  if (urlToken) {
    localStorage.setItem('token', urlToken);
  }
  return urlToken;
};

export default function send<T>(config: CustomerAxiosRequestConfig): AxiosPromise<ResponseData<T>> {
  const language = localStorage.getItem('language') || 'zh';
  const token = getToken();
  const { data = null, url = '', method = 'GET', params, options, headers = {} } = config;
  const requestUrl = url.startsWith('http') ? url : `${ROOT_PATH}${url}`;
  const assignHeaders = { 'Content-Type': 'application/json', 'Content-Language': language, token, ...headers, };
  const { loading = true } = options || {};
  const formatParams = method.toUpperCase() === 'GET' ? md5sign(params) : params;

  loading && showLoading();

  return axios({ url: requestUrl, method, data, headers: assignHeaders, params: formatParams })
    .then((res: AxiosResponse<ResponseData<T>>) => {
      const { data: { code, msg } } = res;
      const { pathname, search } = location;
      // if (+code === 105562) {
      //   window.location.href = `${location.origin}`;
      // } else
      if (+code === 105009) {
        clearExcept();
        location.replace(`${location.origin}/login?redirect=${pathname === '/login' ? '/home' : pathname}${search}`);
      } else if (+code !== 0) {
        msg && message.error(msg);
      }

      return res;
    })
    .catch((e) => {
      console.error('API request error:', e);
      throw e;
    })
    .finally(() => {
      loading && hideLoading();
    });
}